interface CookieStoreSetOptions {
  name: string
  value: string
  path?: string
  maxAge?: number
}

interface CookieStoreApi {
  set: (options: CookieStoreSetOptions) => Promise<void>
}

export interface CookieOptions {
  maxAge?: number

  path?: string
}

const DEFAULT_COOKIE_OPTIONS: Required<CookieOptions> = {
  maxAge: 60 * 60 * 24 * 7,
  path: '/',
}

const setCookieLegacy = (name: string, value: string, path: string, maxAge: number): void => {
  const cookieString = `${name}=${value}; path=${path}; max-age=${maxAge}`
  Reflect.set(document, 'cookie', cookieString)
}

export const getCookie = (name: string): string | null => {
  if (typeof document === 'undefined') return null

  const cookies = document.cookie.split(';')
  for (const cookie of cookies) {
    const [cookieName, cookieValue] = cookie.trim().split('=')
    if (cookieName === name) return cookieValue ?? null
  }
  return null
}

export const setCookie = (name: string, value: string, options: CookieOptions = {}): void => {
  if (typeof window === 'undefined') return

  const { maxAge, path } = { ...DEFAULT_COOKIE_OPTIONS, ...options }
  const cookieStore = (window as Window & { cookieStore?: CookieStoreApi }).cookieStore

  if (cookieStore) {
    cookieStore
      .set({ name, value, path, maxAge })
      .catch(() => setCookieLegacy(name, value, path, maxAge))
    return
  }

  setCookieLegacy(name, value, path, maxAge)
}

export const deleteCookie = (name: string, path = '/'): void => {
  setCookie(name, '', { maxAge: 0, path })
}
